import { Button, SvgExternalLink } from '@loomhq/lens';
import React from 'react';

import * as analytics from 'utilities/analytics';
import * as intercom from 'utilities/intercom';

import CreateFoldersImg from 'img/workspace-onboarding/create-folders.png';

import DashboardOnboardingCard, {
  DashboardOnboardingSecondaryAction,
} from '../..';
import { DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED } from '../../../../../../constants/events';
import { ORGANIZE_FOLDERS_CARD_KEY } from '../../../../../../../../shared/constants/workspaceOnboarding';

const SUPPORT_ARTICLE_LINK =
  'https://support.loom.com/hc/en-us/articles/360002216638-Organizing-your-video-folders-';

const PRODUCT_TOUR_ID = 115041;
const PRODUCT_TOUR_LINK = `https://www.loom.com/team-videos?product_tour_id=${PRODUCT_TOUR_ID}`;

const OrganizeFoldersCard = () => {
  const secondaryAction = (
    <DashboardOnboardingSecondaryAction
      icon={<SvgExternalLink />}
      onClick={() => {
        analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
          type: 'secondary',
          card: ORGANIZE_FOLDERS_CARD_KEY,
        });

        window.open(SUPPORT_ARTICLE_LINK);
      }}
    >
      Learn how
    </DashboardOnboardingSecondaryAction>
  );

  const tourIsOnSamePage = PRODUCT_TOUR_LINK.includes(window.location.pathname);

  const buttonAction = () => {
    analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
      type: 'secondary',
      card: ORGANIZE_FOLDERS_CARD_KEY,
    });

    if (!tourIsOnSamePage) {
      window.location.href = PRODUCT_TOUR_LINK;
    } else {
      intercom.startTour(PRODUCT_TOUR_ID);
    }
  };

  const primaryAction = <Button onClick={buttonAction}>Show me how</Button>;

  const centerpiece = <img src={CreateFoldersImg} />;

  return (
    <DashboardOnboardingCard
      cardKey={ORGANIZE_FOLDERS_CARD_KEY}
      heading="Organize the Team Library"
      description="Create folders to group related videos."
      centerpiece={centerpiece}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      completeMessage="You created a folder in the Team Library 🗂"
    />
  );
};

export default OrganizeFoldersCard;
